import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-divider',
  imports: [CommonModule],
  template: `
    <!-- A divider without a label is a visible rule (Figma section separator);
         with a label it keeps the legacy section-heading look above the rule, unless the form
         builder chose 'heading': then the label reads like the route block's own heading
         ("Locaties en activiteiten"), so a divider can introduce a block that sits next to it. -->
    @if (props.label) {
      @if (props['headingStyle'] === 'heading') {
        <h3>{{ props.label }}</h3>
      } @else {
        <h4 class="text-sm uppercase font-bold">{{ props.label }}</h4>
      }
    }
    <!-- Figma's divider component draws a 1px #CAC4D0 line (see --dd-divider); the
         card-border token it used before is Border/Default #EEEFF1, which is invisible on
         a white card.
         border-b-0 is load-bearing: Fuse's base layer gives every hr a bottom border
         (@fuse/styles/tailwind.scss), so border-t alone rendered TWO 1px lines — a 2px
         rule instead of Figma's hairline. my-6 = the 24px gap of the Figma card's
         auto-layout, replacing both Fuse's 32px and the earlier 16px. -->
    <hr class="my-6 border-t border-b-0" style="border-color: var(--dd-divider)" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDividerComponent extends FieldType<any> {}
